export default {
  'career.title': 'Career',
  'career.titleHighlight': 'History',
  'career.subtitle': 'Professional and educational background',

  // Sections
  'career.business.title': 'Business',
  'career.education.title': 'Education',
  'career.skills.title': 'Technical Skills',
  'career.skills.description': 'I cover wide range of software skills.',

  // Status labels
  'career.status.enrolled': 'Enrolled',
  'career.status.completed': 'Completed',
  'career.status.graduated': 'Graduated',

  // Business Career
  'career.business.nvidia.company': 'NVIDIA',
  'career.business.nvidia.position': 'Senior Solution Architect',
  'career.business.unity.company': 'Unity Technologies Japan',
  'career.business.unity.position': 'Senior Program Manager',
  'career.business.playlife.company': 'Play Life Studio',
  'career.business.playlife.position': 'CEO',
  'career.business.hakuhodo.company': 'Hakuhodo Inc.',
  'career.business.hakuhodo.position': 'Research Director',
  'career.business.ricoh.company': 'Ricoh Company',
  'career.business.ricoh.position': 'Project Manager / Software Engineer',
  'career.business.squareenix.company': 'Square Enix',
  'career.business.squareenix.position': 'Game Programmer',
  'career.business.sony.company': 'Sony Corporation',
  'career.business.sony.position': 'Software Engineer',

  // Education
  'career.education.utokyo.institution': 'The University of Tokyo',
  'career.education.utokyo.degree': 'Graduate School of Interdisciplinary Information Studies, Doctoral Program',
  'career.education.keio_grad.institution': 'Keio University',
  'career.education.keio_grad.degree': 'Graduate School of Media Design, Master\'s Program',
  'career.education.keio.institution': 'Keio University',
  'career.education.keio.degree': 'Faculty of Environment and Information Studies',
};
